module.exports = __webpack_public_path__ + "img/enps.5e407296.svg";